import axios from "axios";
import authHeader from "./auth-header";

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
  getInventory(params = {}) {
    return axios.get(`${API_URL}/shopify-ve/inventory`, {
      headers: authHeader(),
      params,
    });
  },
  getPosProducts(params = {}) {
    return axios.get(`${API_URL}/shopify-ve/inventory`, {
      headers: authHeader(),
      params,
    });
  },
  getOrders(params = {}) {
    return axios.get(`${API_URL}/shopify-ve/orders`, {
      headers: authHeader(),
      params,
    });
  },
  syncOrders(pageInfo = null) {
    const payload = pageInfo ? { page_info: pageInfo } : {};
    return axios.post(`${API_URL}/shopify-ve/orders/sync`, payload, { headers: authHeader() });
  },
  updateOrderStatus(id, status) {
    return axios.patch(
      `${API_URL}/shopify/orders/shopify-ve/${id}/status`,
      { status },
      { headers: authHeader() }
    );
  },
  getOrder(id) {
    return axios.get(`${API_URL}/shopify/orders/shopify-ve/${id}`, {
      headers: authHeader(),
    });
  },
  syncOrderToKubapp(id) {
    return axios.post(`${API_URL}/shopify-ve/orders/${id}/kubapp-sync`, {}, { headers: authHeader() });
  },
  initPicking(shopifyOrderId) {
    return axios.post(`${API_URL}/shopify-ve/orders/picking/init`, { shopify_order_id: shopifyOrderId }, { headers: authHeader() });
  },
  scanPicking(shopifyOrderId, sku) {
    return axios.post(`${API_URL}/shopify-ve/orders/picking/scan`, { shopify_order_id: shopifyOrderId, sku }, { headers: authHeader() });
  },
  togglePickingItem(pickingId) {
    return axios.patch(`${API_URL}/shopify-ve/orders/picking/${pickingId}/toggle`, {}, { headers: authHeader() });
  },
  getPicking(orderId) {
    return axios.get(`${API_URL}/shopify-ve/orders/picking/${orderId}`, { headers: authHeader() });
  },
  getPickingListPdf(ids) {
    return axios.post(
      `${API_URL}/shopify-ve/orders/picking-list-pdf`,
      { ids },
      { headers: authHeader(), responseType: "blob" }
    );
  },
  createPosSale(payload) {
    return axios.post(`${API_URL}/shopify-ve/pos/sales`, payload, { headers: authHeader() });
  },
  getPosSale(id) {
    return axios.get(`${API_URL}/shopify-ve/pos/sales/${id}`, { headers: authHeader() });
  },
  syncPosSale(id) {
    return axios.post(`${API_URL}/shopify-ve/pos/sales/${id}/sync`, {}, { headers: authHeader() });
  },
  batchUpdateOrderStatus(orders, status) {
    return axios.post(
      `${API_URL}/shopify/orders/batch-status`,
      { orders, status },
      { headers: authHeader() }
    );
  },
  syncProducts() {
    return axios.post(`${API_URL}/shopify-ve/products/sync`, {}, { headers: authHeader() });
  },
  pushToShopify() {
    return axios.post(`${API_URL}/shopify-ve/products/push`, {}, { headers: authHeader() });
  },
  getPushableProductIds() {
    return axios.get(`${API_URL}/shopify-ve/products/pushable-ids`, { headers: authHeader() });
  },
  pushProductToShopify(productId) {
    return axios.post(`${API_URL}/shopify-ve/products/${productId}/push`, {}, { headers: authHeader() });
  },
  generateToken(payload = {}) {
    return axios.post(`${API_URL}/shopify-ve/oauth/token`, payload, { headers: authHeader() });
  },
  updateInventory(productId, payload = {}) {
    return axios.patch(`${API_URL}/shopify-ve/inventory/${productId}`, payload, {
      headers: authHeader(),
    });
  },
  uploadProductImage(productId, file) {
    const formData = new FormData();
    formData.append("image", file);
    return axios.post(`${API_URL}/shopify-ve/inventory/${productId}/image`, formData, {
      headers: { ...authHeader(), "Content-Type": "multipart/form-data" },
    });
  },
};
